<ng-container *ngIf="!isSVG; else svgRef">
  <mat-icon class="icon" [fontSet]="fontSet" [ngClass]="[size | iconSize, state | iconState]">{{ name }}</mat-icon>
</ng-container>

<ng-template #svgRef>
  <img class="icon--svg" [src]="'../../../assets/icons/' + svgName" [alt]="'Referencing icon for' + svgName" />
</ng-template>
